import React, { useState, useEffect } from "react";
import SidebarMenu from "../../../Components/SidebarMenu";
import { Link, useParams } from "react-router-dom";
import api from "../../../Services/api";
import axios from "axios";
import { useAuth } from "../../../Hooks/useAuth";
import MainButton from "../../../Components/MainButton";
import {
	Content,
	Info,
	InfoBlock,
	InfoTitle,
	PacientInfo,
	PageTitle,
	Redefinir,
	PacientRow,
	MissingInfo,
	RightDiv,
	PageContainerDiv,
	Background,
	InputEdit,
} from "./styles";
import img from "./assets/back.png";
import { toast, ToastContainer } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import ReactLoading from "react-loading";

function Perfil() {
	const { user } = useAuth();
	const [editMode, setEditMode] = useState(false);
	const [nome, setNome] = useState("");
	const [sobrenome, setSobrenome] = useState("");
	const [email, setEmail] = useState("");
	const [cnpj, setCnpj] = useState("");
	const [cpf, setCpf] = useState("");
	const [complemento, setComplemento] = useState("");
	const [telefone, setTelefone] = useState("");
	const [endereco, setEndereco] = useState("");
	const [bairro, setBairro] = useState("");
	const [cidade, setCidade] = useState("");
	const [estado, setEstado] = useState("");
	const [cep, setCep] = useState("");
	const [chavepix, setChavepix] = useState("");
	const [tipochave, setTipochave] = useState("");
	const [twitterUrl, setTwitterUrl] = useState("");
	const [instagramUrl, setInstagramUrl] = useState("");
	const [facebookUrl, setFacebookUrl] = useState("");
	const [creditosConsulta, setCreditosConsulta] = useState("");
	const [especialidades, setEspecialidades] = useState([]);
	const [loadingEditar, setLoadingEditar] = useState(false);

	useEffect(() => {
		if (user) {
			setNome(user.NO_primeiro_nome || "");
			setSobrenome(user.NO_ultimo_nome || user.DS_razao_social || "");
			setEmail(user.DS_email || "");
			setCpf(user.NU_cpf || "");
			setCnpj(user.NU_cnpj || "");
			setTelefone(user.NU_telefone || "");
			setComplemento(user.DS_complemento || "");
			setEndereco(user.rua?.NO_rua || "");
			setBairro(user.bairro?.NO_bairro || "");
			setCidade(user.cidade?.NO_cidade || "");
			setEstado(user.estado?.NO_estado || "");
			setCep(user.rua?.NU_cep || ""); // Assuming CEP is in user.rua or similar, but let's stick to what we see in display logic if possible, or leave empty if not sure. Display uses user.rua... wait, user structure not fully visible but display uses user.rua.NO_rua.
			// Re-checking check logic below for display
			setTwitterUrl(user.DS_twitter || "");
			setInstagramUrl(user.DS_instagram || "");
			setFacebookUrl(user.DS_facebook || "");
			setChavepix(user.dados_pix?.CD_chave_pix || "");
			setTipochave(user.dados_pix?.TP_chave_pix || "");
			setCreditosConsulta(user.medico?.VL_consulta_em_credito || "");
			// Especialidades is a bit more complex, ignoring for now as it's separate state
		}
	}, [user]);

	const { updateUserData } = useAuth();

	const handleCepBlur = async (event) => {
		const cepInput = event.target.value.replace(/\D/g, "");
		console.log("cep", event, "cep", cep, cepInput);

		if (cepInput.length === 8) {
			try {
				const response = await axios.get(`https://viacep.com.br/ws/${cepInput}/json/`);
				const { data } = response;
				if (!data.erro) {
					setCep(cepInput);
					setEndereco(data.logradouro);
					setBairro(data.bairro);
					setCidade(data.localidade);
					setEstado(data.uf);
				} else {
					// Limpar os outros campos se o CEP for inválido ou não for encontrado
					setCep(cep);
					setEndereco(endereco);
					setBairro(bairro);
					setCidade(cidade);
					setEstado(estado);

					console.log("CEP inválido ou não encontrado");
				}
			} catch (error) {
				// Tratar erros de requisição
				console.log("Erro ao buscar CEP", error);
			}
		} else {
			// Limpar os outros campos caso o CEP não tenha 8 dígitos
			setCep(cep);
			setEndereco(endereco);
			setBairro(bairro);
			setCidade(cidade);
			setEstado(estado);
		}
	};

	function removeNullable(obj) {
		return Object.fromEntries(
			Object.entries(obj).filter(
				([_, value]) => value !== null && value !== undefined && value !== ''
			)
		);
	}

	async function handleEdit() {
		setLoadingEditar(true);
		const especialidadesArray = [];
		console.log(especialidades);
		await especialidades.map((objeto) => {
			especialidadesArray.push(objeto.value);
		});
		try {
			const infoAlteradas = {
				NO_primeiro_nome: nome,
				NO_ultimo_nome: user.NU_cnpj ? undefined : sobrenome,
				DS_razao_social: user.NU_cnpj ? sobrenome : undefined,
				DS_email: email,
				DS_twitter: twitterUrl,
				DS_facebook: facebookUrl,
				DS_instagram: instagramUrl,
				NU_telefone: telefone,
				NU_cpf: cpf,
				NU_cnpj: cnpj,
				CD_chave_pix: chavepix,
				TP_chave_pix: tipochave,
				VL_consulta_em_credito: String(creditosConsulta),
				DS_complemento: complemento,
				NO_rua: endereco,
				NO_bairro: bairro,
				NO_cidade: cidade,
				NO_estado: estado,
				especialidades: JSON.stringify(especialidadesArray),
			};
			const infosFiltradas = removeNullable(infoAlteradas);
			infosFiltradas.TP_chave_pix === user.dados_pix.TP_chave_pix && delete infosFiltradas.TP_chave_pix;
			console.log("infos", infosFiltradas);
			const response = await api.patch(`/medicos/atualizar_dados`, infosFiltradas);

			// Merge existing user data with the response to ensure nested relations (like medico, rua, etc.) are preserved
			// if the backend response doesn't return them fully populated.
			const updatedUser = { ...user, ...response.data };

			await updateUserData(updatedUser);
			console.log("dados", response.data);
			setEditMode(false);
			const showToastMessage = () => {
				toast.success(`Sucesso ao editar perfil `, {
					position: toast.POSITION.TOP_CENTER,
				});
			};
			showToastMessage();
		} catch (error) {
			console.log(error, "Erro ao editar o perfil");
			const showToastMessageError = () => {
				toast.error(`Erro ao editar perfil `, {
					position: toast.POSITION.TOP_CENTER,
				});
			};
			showToastMessageError();
		}
		setLoadingEditar(false);
	}

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			width: "16vw",
			minHeight: "30px",
			borderRadius: "10px",
			backgroundColor: "#fafafa",
			fontSize: "18px",
			color: "black",
			border: "1px solid #d5d5d5",
		}),
		option: (provided, state) => ({
			...provided,
			color: "black", // Cor do texto das opções
		}),
	};
	const customStyles1 = {
		control: (provided, state) => ({
			...provided,
			width: "16vw",
			minHeight: "30px",
			borderRadius: "10px",
			backgroundColor: "#fafafa",
			fontSize: "16px",
			color: "black",
			border: "1px solid #d5d5d5",
		}),
		option: (provided, state) => ({
			...provided,
			color: "black", // Cor do texto das opções
		}),
	};

	const specialtiesList = [
		"Acupuntura",
		"Agente comunitário de saúde",
		"Alergia e imunologia",
		"Anatomopatologista",
		"Anestesiologista",
		"Angiologia",
		"Assistente social",
		"Atendente de consultório dentário",
		"Auxiliar de enfermagem",
		"Auxiliar de farmácia de manipulação",
		"Auxiliar de laboratório de análises clínicas",
		"Auxiliar de radiologia (revelação fotográfica)",
		"Auxiliar em saúde bucal da estratégia de saúde da família",
		"Auxiliar técnico em patologia clínica",
		"Biólogo",
		"Biomédico",
		"Cancerologista cirúrgico (oncologista cirúrgico)",
		"Cardiologia",
		"Cirurgia cardiovascular",
		"Cirurgia da mão",
		"Cirurgia de cabeça e pescoço",
		"Cirurgia do aparelho digestivo",
		"Cirurgia geral",
		"Cirurgia pediátrica",
		"Cirurgia plástica",
		"Cirurgia torácica",
		"Cirurgia vascular",
		"Cirurgião dentista - clínico geral",
		"Cirurgião dentista - dentística",
		"Cirurgião dentista - endodontista",
		"Cirurgião dentista - estratégia saúde da família",
		"Cirurgião dentista - ortopedista e ortodontista",
		"Cirurgião dentista - patologista bucal",
		"Cirurgião dentista - radiologista",
		"Cirurgião dentista - traumatologista bucomaxilofacial",
		"Cirurgião dentista de saúde coletiva",
		"Clínica médica",
		"Clínico geral",
		"Curso de dependência química",
		"Dermatologia",
		"Diretor de serviços de saúde",
		"Educador físico",
		"Endocrinologia e metabologia",
		"Endoscopista",
		"Enfermeiro",
		"Farmacêutico",
		"Farmacêutico bioquímico",
		"Fisiatra",
		"Fisioterapeuta esportivo",
		"Fisioterapeuta geral",
		"Fonoaudiólogo",
		"Gastroenterologia",
		"Geneticista (médico)",
		"Geriatra",
		"Ginecologia e obstetrícia",
		"Hematologia",
		"Hemoterapeuta",
		"Hiperbarista",
		"Infectologista",
		"Instrumentador cirúrgico",
		"Intensivista",
		"Legista",
		"Massagista",
		"Mastologista",
		"Medicina estética",
		"Medicina nuclear",
		"Médico coloproctologista",
		"Médico de família e comunidade",
		"Médico do trabalho",
		"Médico em medicina de tráfego",
		"Médico em medicina preventiva e social",
		"Médico estratégia saúde da família",
		"Médico homeopata",
		"Médico patologista clínico / medicina laboratorial",
		"Médico residente",
		"Médico veterinário",
		"Musicoterapeuta",
		"Nefrologia",
		"Neurocirurgião",
		"Neurofisiologia clínica",
		"Neurologia",
		"Neuropsicólogo",
		"Nutricionista",
		"Nutrologia",
		"Odontologista",
		"Oftalmologista",
		"Oncologia",
		"Ortodontia e ortopedia facial",
		"Ortopedia e traumatologia",
		"Ortoptista",
		"Otorrinolaringologista",
		"Outras",
		"Patologista",
		"Pediatria",
		"Pneumologia",
		"Podologia",
		"Preparador físico",
		"Psicologia clínica",
		"Psicopedagogo",
		"Psiquiatria",
		"Radiologista / imagenologista",
		"Radioterapeuta",
		"Reumatologia",
		"Sanitarista",
		"Terapeuta",
		"Terapeuta ocupacional",
		"Trabalhador de serviços de limpeza e conservação de áreas públicas",
		"Técnico de enfermagem",
		"Técnico de enfermagem do trabalho",
		"Técnico de laboratório de análises físico-químicas (materiais de construção)",
		"Técnico em acupuntura",
		"Técnico em fotônica",
		"Técnico em higiene dental",
		"Técnico em patologia clínica",
		"Técnico em radiologia e imagenologia",
		"Urologia",
		"Visitador sanitário",
	];

	const formattedList = specialtiesList.map((especialidades) => {
		return { label: especialidades, value: especialidades };
	});

	const chavesList = [
		{ label: "CPF", value: "CPF" },
		{ label: "E-mail", value: "EMAIL" },
		{ label: "Telefone", value: "TELEFONE" },
		{ label: "CNPJ", value: "CNPJ" },
	];

	return (
		<PageContainerDiv>
			<SidebarMenu />
			<Background>
				<RightDiv>
					<PageTitle>Perfil</PageTitle>
					<Content>
						<PacientInfo>
							<InfoBlock>
								<InfoTitle>Nome:</InfoTitle>
								{editMode ? (
									<InputEdit type="text" value={nome} onChange={(e) => setNome(e.target.value)} />
								) : (
									<Info>{user.NO_primeiro_nome}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>{user.NO_ultimo_nome ? "Sobrenome:" : "Razão Social:"}</InfoTitle>
								{editMode ? (
									<InputEdit type="text" value={sobrenome} onChange={(e) => setSobrenome(e.target.value)} />
								) : (
									<Info>{user.NO_ultimo_nome || user.DS_razao_social}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Email:</InfoTitle>
								{editMode ? (
									<InputEdit
										type="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
								) : (
									<Info>{user.DS_email}</Info>
								)}
							</InfoBlock>
							{user.NU_cpf && (
								<InfoBlock>
									<InfoTitle>CPF:</InfoTitle>
									{editMode ? (
										<InputEdit
											type="text"
											value={cpf}
											onChange={(e) => setCpf(e.target.value)}
										/>
									) : (
										<MissingInfo>
											{user.NU_cpf ? (
												<Info>{user.NU_cpf}</Info>
											) : (
												"Adicione seu CPF"
											)}
										</MissingInfo>
									)}
								</InfoBlock>
							)}
							{user.NU_cnpj && (
								<InfoBlock>
									<InfoTitle>CNPJ:</InfoTitle>
									{editMode ? (
										<InputEdit
											type="text"
											value={cnpj}
											onChange={(e) => setCnpj(e.target.value)}
										/>
									) : (
										<MissingInfo>
											{user.NU_cnpj ? (
												<Info>{user.NU_cnpj}</Info>
											) : (
												"Adicione seu CNPJ"
											)}
										</MissingInfo>
									)}
								</InfoBlock>
							)}
							<InfoBlock>
								<InfoTitle>Especialidades</InfoTitle>
								{editMode ? (
									<CreatableSelect
										options={formattedList}
										isMulti
										id="Especialidades"
										name="Especialidades"
										required
										defaultValue={Object.values(user.medico.especialidades).map((value, key) => {
											return { label: value.NO_especialidade, value: value.NO_especialidade };
										})}
										onChange={(e) =>
											setEspecialidades(
												e.map((value, key) => {
													return { nome: value.value };
												})
											)
										}
										styles={customStyles}
										placeholder={"Selecione as especialidades"}
									/>
								) : (
									<Info>{user.medico.especialidades.map((obj) => obj.NO_especialidade).join(', ')}</Info>
								)}
							</InfoBlock>{" "}
							<InfoBlock>
								{editMode ? (
									<>
										<InfoTitle>Valor da consulta:</InfoTitle>
										<InputEdit
											type="text"
											defaultValue={creditosConsulta}
											onChange={(e) => setCreditosConsulta(e.target.value)}
										/>
									</>
								) : (
									""
								)}
							</InfoBlock>
						</PacientInfo>
						<PacientInfo>
							<InfoBlock>
								<InfoTitle>Twitter:</InfoTitle>
								{editMode ? (
									<InputEdit
										type="text"
										value={twitterUrl}
										onChange={(e) => setTwitterUrl(e.target.value)}
									/>
								) : (
									<a href={user.DS_twitter} target="_blank" rel="noopener noreferrer">
										<MissingInfo>
											{user.DS_twitter ? <Info>{user.DS_twitter}</Info> : "Edite a URL do seu Twitter"}
										</MissingInfo>
									</a>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Instagram:</InfoTitle>
								{editMode ? (
									<InputEdit
										type="text"
										value={instagramUrl}
										onChange={(e) => setInstagramUrl(e.target.value)}
									/>
								) : (
									<a href={user.DS_instagram} target="_blank" rel="noopener noreferrer">
										<MissingInfo>
											{user.DS_instagram ? (
												<Info>{user.DS_instagram}</Info>
											) : (
												"Edite a URL do seu Instagram"
											)}
										</MissingInfo>
									</a>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Facebook:</InfoTitle>
								{editMode ? (
									<InputEdit
										type="text"
										value={facebookUrl}
										onChange={(e) => setFacebookUrl(e.target.value)}
									/>
								) : (
									<a href={user.DS_facebook} target="_blank" rel="noopener noreferrer">
										<MissingInfo>
											{user.DS_facebook ? <Info>{user.DS_facebook}</Info> : "Edite a URL do seu Facebook"}
										</MissingInfo>
									</a>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Chave PIX:</InfoTitle>
								{editMode ? (
									<InputEdit
										type="chavepix"
										value={chavepix}
										onChange={(e) => setChavepix(e.target.value)}
									/>
								) : (
									<Info>{user.dados_pix.CD_chave_pix}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Tipo de chave</InfoTitle>
								{editMode ? (
									<CreatableSelect
										id="tipochave"
										name={"tipochave"}
										options={chavesList}
										onChange={(e) => setTipochave(e.value)}
										styles={customStyles1}
										defaultValue={Object.values(chavesList).filter((element) =>
											element.value.includes(user.dados_pix.TP_chave_pix)
										)}
									/>
								) : (
									<Info>
										{Object.values(chavesList)
											.filter((element) =>
												element.value.includes(user.dados_pix.TP_chave_pix)
											)
											.map((obj) => obj.label)}
									</Info>
								)}
							</InfoBlock>
						</PacientInfo>
						<PacientInfo>
							{editMode ? (
								<InfoBlock>
									<InfoTitle>CEP</InfoTitle>
									<InputEdit type="text" onChange={(e) => handleCepBlur(e)} />
								</InfoBlock>
							) : (
								""
							)}

							<InfoBlock>
								<InfoTitle>Estado</InfoTitle>
								{editMode ? (
									<InputEdit
										readOnly
										type="text"
										value={estado}
										onChange={(e) => setEstado(e.target.value)}
									/>
								) : (
									<Info>{user.estado.NO_estado}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Cidade</InfoTitle>
								{editMode ? (
									<InputEdit
										readOnly
										type="text"
										value={cidade}
										onChange={(e) => setCidade(e.target.value)}
									/>
								) : (
									<Info>{user.cidade.NO_cidade}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Bairro</InfoTitle>
								{editMode ? (
									<InputEdit
										readOnly
										type="text"
										value={bairro}
										onChange={(e) => setBairro(e.target.value)}
									/>
								) : (
									<Info>{user.bairro.NO_bairro}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Endereço</InfoTitle>
								{editMode ? (
									<InputEdit
										readOnly
										type="text"
										value={endereco}
										onChange={(e) => setEndereco(e.target.value)}
									/>
								) : (
									<Info>{user.rua.NO_rua}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								<InfoTitle>Complemento</InfoTitle>
								{editMode ? (
									<InputEdit
										readOnly
										type="text"
										value={complemento}
										onChange={(e) => setComplemento(e.target.value)}
									/>
								) : (
									<Info>{user.DS_complemento ?? "Edite seu complemento"}</Info>
								)}
							</InfoBlock>
							<InfoBlock>
								{editMode ? (
									""
								) : (
									<>
										<InfoTitle>Valor da consulta:</InfoTitle>
										<Info>{user.medico.VL_consulta_em_credito}</Info>
									</>
								)}
							</InfoBlock>
						</PacientInfo>
					</Content>
					{editMode ? (
						<Redefinir>
							<MainButton disabled={loadingEditar} onClick={handleEdit}>
								{!loadingEditar ?
									"Salvar" :
									<ReactLoading
										type="spin"
										color="#ffffff"
										height={"30px"}
										width={"30px"}
									/>
								}
							</MainButton>
							<MainButton onClick={() => setEditMode(false)}>Cancelar</MainButton>
						</Redefinir>
					) : (
						<Redefinir>
							<MainButton onClick={() => setEditMode(true)}>Editar Perfil</MainButton>
							<Link to="/redefinicao-de-senha">
								<MainButton>Redefinir senha</MainButton>
							</Link>
						</Redefinir>
					)}
				</RightDiv>
			</Background>
		</PageContainerDiv>
	);
}

export default Perfil;
